import React from "react";
import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { API, fileUpload } from "../../../../config";
import Spin from "../../../common/Spin";

const AcceptInvitation = ({
  id,
  showAcceptInvitation,
  handleInvitations,
  toggleShowAcceptInvitationModal,
}) => {
  const [loading, setLoading] = useState(false);

  const handleAcceptInvitation = async () => {
    const formData = new FormData();
    formData.append("status", 1);
    formData.append("_method", "PUT");
    try {
      setLoading(true);
      const { data } = await fileUpload(`${API.INVITATIONS}/${id}`, formData);
      setLoading(false);
      toast.success(data?.message);
      handleInvitations();
      toggleShowAcceptInvitationModal();
    } catch (e) {
      setLoading(false);
      return null;
    }
  };
  return (
    <Modal
      size="lg"
      show={showAcceptInvitation}
      onHide={toggleShowAcceptInvitationModal}
      dialogClassName="modal-50w small-popup review-popup small-review"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="mb-0" closeButton>
        Accept Invitation
      </Modal.Header>
      <Modal.Body>
        {loading && <Spin />}
        <div className="modal-body">
          Are your sure you want to accept this invitation?
        </div>
        <div className="modal-footer">
          <Button
            type="Button"
            className="btn btn-secondary"
            onClick={() => {
              toggleShowAcceptInvitationModal();
            }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            className="btn btn-primary"
            data-dismiss="modal"
            onClick={() => {
              handleAcceptInvitation();
            }}
          >
            Yes
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AcceptInvitation;
